module.exports = __webpack_public_path__ + "img/config-fail.a7bd5d68.svg";